import type { Logger } from '@kinopoisk-int/logger';

import {
    IYandexMetrikaInitParams,
    IYandexMetrikaParamsHandler,
    IYandexMetrikaReachGoalHandler,
    YandexMetrikaHitHandler,
} from './types';
import { YandexMetrikaService } from './service';
import { YandexMetrikaApi } from './api';

function hasCookie(name: string) {
    return document.cookie.includes(`${name}=`);
}

interface IYandexMetrikaService {
    readonly ymclidPromise: Promise<string | undefined>;

    reachGoal: IYandexMetrikaReachGoalHandler;
    params: IYandexMetrikaParamsHandler;
    hit: YandexMetrikaHitHandler;
}

interface Params {
    metrikaInitParams: IYandexMetrikaInitParams;
    scriptSrc?: string;
    getLogger?: () => Logger;
    maxTries?: number;
    onError?: () => void;
    onSuccess?: () => void;
}

export const createYandexMetrikaService = ({
    metrikaInitParams,
    scriptSrc,
    getLogger,
    maxTries,
    onError,
    onSuccess,
}: Params): IYandexMetrikaService | null => {
    if (typeof window === 'undefined') {
        return null;
    }
    const metrikaApi = new YandexMetrikaApi({
        initialParams: metrikaInitParams,
        scriptSrc,
        getLogger,
        maxTries,
        onError,
        onSuccess,
    });

    return new YandexMetrikaService({
        metrikaApi,
        getLogger,
        debug: hasCookie('_kp_debug'),
    });
};
